import React from "react";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
const DiscountIcon = () => {
  return <LocalOfferIcon sx={{ fill: "white" }} />;
};

export default DiscountIcon;
